import { Md5 } from 'md5-typescript';
import { formSerialize } from '../../utilities/springSerialize';

export class SearchRating {
  init() {
    const ratingForm = document.getElementById('rating-form') as HTMLFormElement;
    if (ratingForm) {
      const quickRatings = document.querySelectorAll('.pues-ratings .rate-item');
      const feedbackSubmit = document.querySelector('.pues-rating-submit');
      quickRatings.forEach((item: HTMLElement) => {
        item.addEventListener('click', () => {
          (ratingForm.querySelector('[name="score"]') as HTMLInputElement).value = item.dataset.rating;
          let secondStep = false;
          if (parseInt(item.dataset.rating) < 4) {
            secondStep = true;
          }
          this.submitRating(ratingForm, '/product/rating', item.dataset.rating, secondStep);
        });
      });

      feedbackSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        const getRatingId = document.getElementById('rating-form').dataset.ratingId;
        this.submitRating(ratingForm, '/product/rating/feedback/' + getRatingId + '/' + Md5.init(getRatingId + '-rating'));
        setTimeout(() => {
          (document.querySelector('.feedback-success') as HTMLElement).classList.add('show');
        }, 550)
      });
    }
  }

  submitRating(form: HTMLFormElement, url: string, score?: string, secondStep?: boolean) {
    window.fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formSerialize(form),
      })
      .then(response => response.json())
      .then((data: any) => {
        if (data.id || data.id === 0) {
          form.dataset.ratingId = data.id;
        }
        const successMsg = document.querySelector('.pues-rating-msg') as HTMLElement;
        const successIcon = successMsg.querySelector('i');
        const textareaContainer = (document.querySelector('.rating-textarea') as HTMLElement);
        const textarea = (textareaContainer.querySelector('textarea') as HTMLTextAreaElement);
        const feedbackSubmit = document.querySelector('.pues-rating-submit') as HTMLElement;
        textarea.addEventListener('input', () => {
          if (textarea.value.length > 0) {
            feedbackSubmit.classList.remove('disabled');
          }
          if (textarea.value.length === 0) {
              feedbackSubmit.classList.add('disabled');
          }
        });
        (document.querySelector('.pues-ratings') as HTMLElement).style.display = 'none';
        if (score && successMsg) {
          successMsg.dataset.rate = score;

          switch (score) {
            case '1':
              successMsg.querySelector('i').classList.add('uil-angry');
              break;
            case '2':
              successMsg.querySelector('i').classList.add('uil-frown');
              break;
            case '3':
              successMsg.querySelector('i').classList.add('uil-meh');
              break;
            case '4':
              successMsg.querySelector('i').classList.add('uil-smile');
              break;
            case '5':
              successMsg.querySelector('i').classList.add('uil-grin');
              break;
            default:
              successMsg.querySelector('i').classList.add('uil-smile');
              break;
          }
        }
        successMsg.classList.add('show');
        if (secondStep) {
          setTimeout(() => {
            textareaContainer.classList.add('show');
          }, 300);
        } else {
          textareaContainer.classList.remove('show');
        }
      }).catch(err => console.log(err));
  }

}
